// src/app/components/foundation/EmptyState.tsx
import type { ReactNode } from 'react';
import clsx from 'clsx';

export interface EmptyStateProps {
  /** The "nothing here" message. */
  message: ReactNode;
  /** Optional leading icon/illustration. */
  icon?: ReactNode;
  /** Optional action rendered below the message (e.g. a "create" button). */
  action?: ReactNode;
  className?: string;
}

/**
 * Centered "nothing to show" placeholder for lists/tables with zero
 * items. Icon and action are opt-in so a plain one-line message (the
 * common case today) renders with no extra markup weight.
 */
export function EmptyState({ message, icon, action, className }: EmptyStateProps) {
  return (
    <div className={clsx('flex flex-col items-center gap-2 px-5 py-6 text-center', className)}>
      {icon && <div className="text-[var(--vania-colors-text-tertiary,#6b7280)]">{icon}</div>}
      <p className="text-sm text-[var(--vania-colors-text-secondary,#a3aab8)]">{message}</p>
      {action}
    </div>
  );
}
